import camelize from 'camelcase-keys-deep';

export default class Client {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }
}
